function Experience() {
  return (
    <section id="experience">
      <h2>Experience</h2>

      <div className="card">
        <h3>Frontend Developer Intern</h3>
        <p>CodeAlpha (May–Jun 2025)</p>
        <p>Built responsive UI and improved UX.</p>
      </div>

      <div className="card">
        <h3>Cybersecurity Intern</h3>
        <p>SOC Analyst role</p>
      </div>
    </section>
  );
}
export default Experience;